import size from 'lodash/size';

export const getTransportStopCount = transportStops => size(transportStops);
